import { analyticsDebug } from "./browser/plugins/debug.es.js";
import { analyticsFreedom } from "./browser/plugins/freedom/index.es.js";
import { analyticsJest } from "./browser/plugins/jest.es.js";
import { analyticsTealium } from "./browser/plugins/tealium/index.es.js";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  analyticsDebug,
  analyticsFreedom,
  analyticsJest,
  analyticsTealium
}, Symbol.toStringTag, { value: "Module" }));
export {
  index as i
};
